export default {

    api_url: "https://compta-api.solana-eliquides.fr/",
    axiosConfig: {
        headers: {
            'Content-Type': 'multipart/form-data;charset=UTF-8',
        }
    }
  
  }
